import { HttpInterceptorFn } from '@angular/common/http';
import { inject, LOCALE_ID } from '@angular/core';
import { AcceptLanguage, acceptLanguageMap } from './model/accept-language';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const localeId = inject(LOCALE_ID);
  const modifiedReq = req.clone({
    setHeaders: {
      'Accept-Language': getAcceptLanguageLocaleId(localeId),
    },
  });
  return next(modifiedReq);
};

export function getAcceptLanguageLocaleId(locale: string): AcceptLanguage {
  return acceptLanguageMap[locale] || 'hu-HU'; // Default to Hungarian if no language is specified in the URL
}
